class ProductCarousel extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
  }

  onButtonClick(event) {
    event.preventDefault();
    const isPrev = event.currentTarget.name === 'previous';
    const atStart = this.slider.scrollLeft <= 1;
    const atEnd = this.slider.scrollLeft + this.slider.clientWidth >= this.slider.scrollWidth - 1;

    if (isPrev && atStart) {
      this.setSlidePosition(this.slider.scrollWidth);
      return;
    }
    if (!isPrev && atEnd) {
      this.setSlidePosition(0);
      return;
    }

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = isPrev
      ? this.slider.scrollLeft - step * this.sliderItemOffset
      : this.slider.scrollLeft + step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }
}

customElements.define('product-carousel', ProductCarousel);
